import React, { CSSProperties } from "react";
import { StyledDialogMain } from "./style";
import { useDialogOverlayContext } from "../controller/DialogOverlay";
interface DialogMainProps {
  children: React.ReactNode;
  style?: CSSProperties;
}

export const DialogMain = ({ children, style }: DialogMainProps) => {
  const { $size, $state } = useDialogOverlayContext();
  return (
    <StyledDialogMain $size={$size} $state={$state} style={style}>
      {children}
    </StyledDialogMain>
  );
};
